// extracted by mini-css-extract-plugin
export const sectionDownloadBanner = "downloadBanner-module--sectionDownloadBanner--1AD4a";
export const sectionBackground = "downloadBanner-module--sectionBackground--2hxMh";
export const sectionContent = "downloadBanner-module--sectionContent--j7EGv";
export const bannerContent = "downloadBanner-module--bannerContent--34V5j";
export const imgWrap = "downloadBanner-module--imgWrap--331Ny";
export const contentWrap = "downloadBanner-module--contentWrap--zKIE2";
export const downloadBar = "downloadBanner-module--downloadBar--AUHe0";
export const mobileDownloadBar = "downloadBanner-module--mobileDownloadBar--3oGqW";